import React, { useState, useEffect } from "react";
import "./Header.css";
import { Link, useLocation } from "react-router-dom";
import { Button, Form, Nav, Navbar, Container } from "react-bootstrap";

function Header() {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);

  // Read from sessionStorage on first render
  useEffect(() => {
    const stored = sessionStorage.getItem("isRegistered");
    if (stored === "true") {
      setIsRegistered(true);
    }
  }, []);

  const isActive = (path) => (location.pathname === path ? "active" : "");
  const handleNavClick = () => setExpanded(false);

  return (
    <section className="Header">
      <Navbar expand="lg" className="Header_holder" expanded={expanded}>
        <Container>
          <Navbar.Brand as={Link} to={"/"}>
            <div className="logo_holder">
              <img
                src="/assets/images/logo/logo.png"
                alt="logo"
                className="logo_img"
              />
            </div>
          </Navbar.Brand>

          <div className="header_toggle_btn">
            {/* Mobile Section */}
            <div className="mobile_view_section">
              <Form className="d-flex align-items-center gap-3">
                <Link to={"/register"}>
                  <Button className="search_btn">REGISTER</Button>
                </Link>
                {/* <Link to={"/profile"}>
                    <div className="profile_holder">
                      <p>SL</p>
                    </div>
                  </Link> */}
                <Link to={process.env.REACT_APP_LOGIN_URL}>
                  <Button className="search_btn">Login</Button>
                </Link>
              </Form>
            </div>
            <Navbar.Toggle
              aria-controls="navbarScroll"
              onClick={() => setExpanded(!expanded)}
            />
          </div>

          {/* Desktop Section */}
          <Navbar.Collapse id="navbarScroll">
            <Nav className="ms-auto my-2 my-lg-0" navbarScroll>
              <Nav.Link
                as={Link}
                to="/"
                className={isActive("/")}
                onClick={handleNavClick}
              >
                HOME
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/about-us"
                className={isActive("/about-us")}
                onClick={handleNavClick}
              >
                ABOUT US
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/courses"
                className={isActive("/courses")}
                onClick={handleNavClick}
              >
                COURSES
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/contact-us"
                className={isActive("/contact-us")}
                onClick={handleNavClick}
              >
                CONTACT US
              </Nav.Link>
            </Nav>

            <div className="desktop_view_section">
              <Form className="d-flex align-items-center gap-3">
                <Link to={"/register"}>
                  <Button className="search_btn">REGISTER</Button>
                </Link>

                {/* <Link to={"/profile"}>
                      <div className="profile_holder">
                        <p>SL</p>
                      </div>
                    </Link> */}
                <Link to={process.env.REACT_APP_LOGIN_URL}>
                  <Button className="search_btn">Login</Button>
                </Link>

              </Form>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </section>
  );
}

export default Header;
